
import Carousel from "~/components/global/Carousel";
import Breadcrumbs from "~/components/global/Breadcrumbs";
import ProductCards from "~/components/global/ProductCards";
export default {
    spacingDebug: true,
    components: {
        Carousel,
        Breadcrumbs,
        ProductCards,
    },
    props: {
        payload: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    computed: {
        carouselContent() {
            const hero = Array.isArray(this.payload?.hero) ? this.payload.hero : [];
            const categories = Array.isArray(this.payload?.product_categories) ? this.payload.product_categories : [];
            const banners = categories.flatMap((category) => {
                if (!category?.slug || !category?.name) return [];
                const images = Array.isArray(category.images) ? category.images : [];
                const bannerImage = (variant) => images.find((image) => image?.type === "product_category" && image.category === variant && typeof image.path === "string" && image.path.trim());
                const desktop = bannerImage("image");
                const mobile = bannerImage("image_mobile");
                if (!desktop && !mobile) return [];

                const visible = [true, 1, "1"].includes(category.is_info_banner_visible);
                return [
                    {
                        id: `category-banner-${category.slug}`,
                        title: visible ? category.name : "",
                        description: visible ? category.description || "" : "",
                        info_banner_position: category.info_banner_position || "left",
                        cta_btn_label: visible ? "Learn More" : "",
                        link: category.slug === "corporate" ? "/contact-us" : `/products/${category.slug}`,
                        is_anchor: false,
                        is_link_out: false,
                        images: [
                            { category: "image", path: (desktop || mobile).path, alt: (desktop || mobile).alt || category.name },
                            { category: "image_mobile", path: (mobile || desktop).path, alt: (mobile || desktop).alt || category.name },
                        ],
                    },
                ];
            });
            return [...hero, ...banners].map((slide, index) =>
                index === 0
                    ? {
                          ...slide,
                          cta_btn_label: "Choose an Insurance",
                          link: "#product-categories",
                          is_anchor: true,
                          is_link_out: false,
                          tracking: { cta_action: "scroll-down", cta_location: "Banner" },
                      }
                    : slide,
            );
        },
        categoriesContent() {
            const hasCarouselHeading = this.carouselContent.some((slide) => slide.title);
            const fallbackImages = {
                "travel-insurance": "/assets/product-categories/travel-insurance.webp",
                "vehicle-insurance": "/assets/product-categories/vehicle-insurance.webp",
                "property-and-asset-insurance": "/assets/product-categories/property-and-asset-insurance.webp",
                "personal-and-family-insurance": "/assets/product-categories/personal-and-family-insurance.webp",
            };
            const categories = Array.isArray(this.payload?.product_categories) ? this.payload.product_categories : [];

            return {
                heading: {
                    level: hasCarouselHeading ? "h2" : "h1",
                    textContent: "Choose an Insurance",
                    subtextContent: "Protect Yourself and Your Loved Ones With the Right Insurance Plan.",
                    alignment: "center",
                },
                body: {
                    items: categories
                        .filter((category) => category?.slug && category?.name)
                        .map((category) => {
                            const images = Array.isArray(category.images) ? category.images : [];
                            const image = images.find((item) => item?.category === "image_mobile" && item?.path) || images.find((item) => item?.path) || {};
                            return {
                                heading: {
                                    level: hasCarouselHeading ? "h3" : "h2",
                                    textContent: category.name,
                                    alignment: "center",
                                },
                                body: {
                                    textContent: category.description || "",
                                    alignment: "center",
                                },
                                thumbnail: {
                                    image: {
                                        src: image.path || fallbackImages[category.slug] || "",
                                        alt: image.alt || category.name,
                                        url: category.slug === "corporate" ? "/contact-us" : `/products/${category.slug}`,
                                    },
                                },
                            };
                        }),
                },
            };
        },
    },
};
